import { Link as MuiLink } from "@mui/material";
import { PropsWithChildren, ComponentProps } from "react";
import { HistoryState, Link } from "@tanstack/react-router";
import RouterLinkButton from "./components";

type Props = PropsWithChildren<{ to: string; color?: string }>;

const RouterLink = ({ children, to, color }: Props) => {
  return (
    <MuiLink component={Link} to={to} underline="hover" color={color}>
      {children}
    </MuiLink>
  );
};

type ButtonProps = PropsWithChildren<{ to: string; state?: Partial<HistoryState> }> &
  Pick<
    ComponentProps<typeof RouterLinkButton>,
    "variant" | "color" | "size" | "disabled" | "sx" | "onClick" | "target"
  >;

RouterLink.Button = function Button(props: ButtonProps) {
  return <RouterLinkButton {...props} />;
};

export default RouterLink;
